export const ONLY_POST_MSG_PARTNERS = ['tricycle', 'boribori']
